export default {
  recommended: 'Recommended',
};
